import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CustomerSmsTextService} from 'app/blocks/service/api/customer-sms-text.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICustomerSmsText} from 'app/blocks/model/customer-sms-text.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {CustomerSmsText} from 'app/blocks/model/customer-sms-text.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class CustomerSmsTextResource extends AbstractEntityResource<ICustomerSmsText> {
    constructor(customerSmsTextService: CustomerSmsTextService, router: Router) {
        super(
            Resource.CUSTOMER_SMS_TEXTS,
            customerSmsTextService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMER_SMS_TEXTS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMER_SMS_TEXTS),
            (entity?) => new CustomerSmsText(entity),
            (entity) => entity.id,
            'sms'
        );
    }
}
